import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'

import CustomButton from '../../kit/components/CustomButton/CustomButton.js'
import CustomField from '../../kit/components/CustomField/CustomField.js'
import CustomSelect from '../../kit/components/CustomSelect/CustomSelect.js'
import Checkbox from '../../kit/components/Checkbox/Checkbox.js'
import Callout from '../../kit/components/Callout/Callout.js'

import Hydrate from '../../components/Hydrate/Hydrate.js'

import {
  tryToGetOrganizationMembersLog
} from '../../actions/actions.export'

class OrganizationMembersLog extends Component {
  constructor(props){
    super(props);

    this.state = {
      
    }
  }


  componentDidMount(){
    const { dispatch, orgReducer } = this.props;

    const organization = orgReducer.cache[this.props.id];
    if(!organization.membersLog){
      dispatch(tryToGetOrganizationMembersLog({id: this.props.id}));
    }
  }

  render(){

    const { dispatch, orgReducer } = this.props;

    let canManageMembers = false;
    for(var i in orgReducer.memberships){
      if(orgReducer.memberships[i].organization.id === this.props.id){
        if(orgReducer.memberships[i].membership.manage_members){
          canManageMembers = true;
        }
      }
    }

    if(!canManageMembers) return <span/>;


    const organization = orgReducer.cache[this.props.id];

    return <div className={"box"}>
      
      <div className="flex-split margin-bottom-2rem">
        <h4 className="no-margin-top no-margin-bottom">
          Member History
        </h4>
        <div className="list-right">
          {
            (orgReducer.tryingToGetOrganizationMembersLog) ?
            <i className="far fa-spinner-third fa-spin text-muted fa-fw"/>
            :
             <i className="far fa-sync-alt clickable icon-muted-until-hover fa-fw" onClick={()=>{ 
              dispatch(tryToGetOrganizationMembersLog({id: this.props.id}))
            }}/>
          }
        </div>
      </div>

      {
        (organization.membersLog !== undefined) ? 
          <div>
            {
              organization.membersLog.length === 0 ? 
              <p>You haven't invited anyone to join yet.</p>
              :
              organization.membersLog.map((e, i)=>{
                return <div className="subtle-section" key={i}>
                  <div className="margin-bottom-05rem">
                    {
                      e.event === "invite accepted" &&
                      <span>
                        <i className="far fa-user-check text-success text-semi-muted icon-before-text"/> Invite to <span className="text-700">{e.email}</span> was accepted
                      </span>
                    }
                    {
                      e.event === "first member" &&
                      <div>
                        <i className="far fa-user-check text-success text-semi-muted icon-before-text"/> <Hydrate type="user" id={e.by} field="display_name" tooltip={true} placeholder="a user"/> became the founding member
                      </div>
                    }
                    {
                      e.event === "member removed" &&
                      <div>
                        <i className="far fa-user-times text-danger text-semi-muted icon-before-text"/> <Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> was removed from the organization.
                      </div>
                    }
                    {
                      e.event === "member left" &&
                      <div>
                        <i className="far fa-user-times text-danger text-semi-muted icon-before-text"/> <Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> left the organization.
                      </div>
                    }

                    {
                      e.event === "ownership transfer" &&
                      <div>
                        <i className="far fa-user-crown text-blue text-semi-muted icon-before-text"/> <Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> became the owner of the organization
                      </div>
                    }

                    {
                      e.event === "member privilege change" &&
                      <div>
                        {
                          e.privilege_value ?
                          <span>
                            <i className="far fa-user-crown text-success text-semi-muted icon-before-text"/>
                            { e.privilege_name === 'create' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> was given the <span className="text-700">Create Projects</span> privilege</span> } 
                            { e.privilege_name === 'manage_content' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> was given the <span className="text-700">Manage All Projects</span> privilege</span> } 
                            { e.privilege_name === 'manage_info' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> was given the <span className="text-700">Manage Profile</span> privilege</span> } 
                            { e.privilege_name === 'manage_members' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> was given the <span className="text-700">Manage Members</span> privilege</span> } 
                            { e.privilege_name === 'manage_billing' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> was given the <span className="text-700">Manage Billing</span> privilege</span> } 
                          </span>
                          :
                          <span>
                            <i className="far fa-user-crown text-danger text-semi-muted icon-before-text"/> 
                            
                            { e.privilege_name === 'create' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> no longer has the <span className="text-700">Create Projects</span> privilege</span> } 
                            { e.privilege_name === 'manage_content' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> no longer has the <span className="text-700">Manage All Projects</span> privilege</span> } 
                            { e.privilege_name === 'manage_info' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> no longer has the <span className="text-700">Manage Profile</span> privilege</span> } 
                            { e.privilege_name === 'manage_members' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> no longer has the <span className="text-700">Manage Members</span> privilege</span> } 
                            { e.privilege_name === 'manage_billing' && <span><Hydrate  type="user" id={e.actioned_member} field="display_name" tooltip={true} placeholder="a user"/> no longer has the <span className="text-700">Manage Billing</span> privilege</span> } 
                          </span>
                        }

                      </div>
                    }
                  </div>
                  <div className="list-left no-margin-top text-smaller">
                    <span>{moment(e.timestamp).format("dddd, MMMM Do YYYY, h:mm:ss a")}</span>
                    <span className="text-very-muted">|</span>
                    <span className="">{moment(e.timestamp).fromNow()} by <Hydrate  type="user" id={e.by} field="display_name" tooltip={true} placeholder="a user"/></span>
                  </div>
                </div>
              })
            }
            {
              organization.membersLogEmpty ? 
              <p className="text-center text-muted text-smaller">
                You've reached the end of the log.
              </p>
              :
              <div className="flex-column-center margin-top-2rem">
                <CustomButton
                  display="Load More"
                  thinking={orgReducer.tryingToGetOrganizationMembersLog}
                  success={orgReducer.getOrganizationMembersLogSuccess}
                  fail={orgReducer.getOrganizationMembersLogFail}
                  onClick={()=>{
                    dispatch(tryToGetOrganizationMembersLog({
                      id: organization.id,
                      startAfter: organization.membersLog[organization.membersLog.length - 1].id
                    }))
                  }}
                  />
              </div>
            }
          </div>
          :
          <p>You haven't invited anyone to join yet.</p>
      }
    </div>
  }
}


const mapStateToProps = (state) => {
  const { orgReducer } = state;

  return {
    orgReducer
  }
}

export default connect(mapStateToProps)(OrganizationMembersLog);
